// Vendors
import { TweenMax, Expo, Sine } from "gsap/TweenMax";
import SplitText from "./../vendors/gsap/src/bonus-files-for-npm-users/SplitText";

// Utilities
import Config from "../constants/Config";
import { qsa, cls, data } from "./util/dom-utils";

class Text {
    constructor(el) {
        // Elements
        this.$animateEls = qsa("[data-anim]");
        this.checkAnimation = this.checkAnimation.bind(this);
        this.ms = 1000;

        this.typeAnimation = {
            title(el) {
                this.animationTitle(el);
            },
            desc(el) {
                this.animationDesc(el);
            },
            subtitle(el) {
                this.animationSubtitle(el);
            },
            list(el) {
                this.animationList(el);
            }
        };

        this.attachEvents();
    }

    random(min, max) {
        if (max == null) {
            max = min;
            min = 0;
        }
        if (min > max) {
            var tmp = min;
            min = max;
            max = tmp;
        }
        return min + (max - min) * Math.random();
    }

    animationTitle(el) {
        if (!el) return false;

        const mySplitText = new SplitText(el, { type: "lines, chars" });
        const lines = mySplitText.chars;

        TweenMax.set(el, {
            opacity: 1
        });

        TweenMax.killTweensOf(lines);


        TweenMax.staggerFrom(lines, 0.75, {
            y: "35%",
            opacity: 0,
            skewX: this.random(-8, 8),
            ease: Expo.easeOut
        }, .02);

        window.addEventListener("resize", ()=> {
            mySplitText.revert();
        }, false);

    }

    animationDesc(el) {

        let elParagraph = qsa("p", el);
        if (elParagraph.length < 1) return false;

        const mySplitText = new SplitText(elParagraph, { type: "lines" });
        const lines = mySplitText.lines;

        TweenMax.set(el, {
            opacity: 1
        });

        TweenMax.staggerFrom(lines, 0.4, {
            opacity: 0,
            y: "50%",
            skewX: -5,
            ease: Sine.easeOut
        }, 0.06);

        // resize function
        window.addEventListener("resize", ()=> {
            mySplitText.revert();
        }, false);
    }

    animationSubtitle(el) {

        if (!el) return false;

        TweenMax.set(el, {
            opacity: 1
        });

        TweenMax.from(el, 0.6, {
            opacity: 0,
            y: "35%",
            skewX: -5,
            ease: Sine.easeOut
        });

    }

    animationList(el) {
        if (!el) return false;

        const itemList = qsa("li", el);

        TweenMax.set(el, {
            opacity: 1
        });

        TweenMax.staggerFrom(itemList, 0.6, {
            opacity: 0,
            y: "35%",
            skewX: -5,
            ease: Sine.easeOut
        }, 0.1);
    }

    checkAnimation(el) {

        if (!el) return false;

        const type = el._type;
        const delay = el._delay;

        const typeAnimateFn = this.typeAnimation[type];

        if (typeof typeAnimateFn === "function") {
            setTimeout(() => {
                typeAnimateFn.call(this, el);
            }, delay);
        }
    }

    observerScroll() {

        if ("IntersectionObserver" in window) {

            // IntersectionObserver Supported
            let options = {
                threshold: [0.8]
            };

            // Create new IntersectionObserver
            const observer = new IntersectionObserver((entries, observer) => {

                entries.forEach((entry => {

                    const el = entry.target;
                    el._type = data("anim", el);
                    el._delay = data("anim-delay", el) * this.ms;

                    if (entry.intersectionRatio >= 0.8) {

                        if (!cls.has(el, Config.classes.VISIBLE)) {
                            cls.add(el, Config.classes.VISIBLE)
                            setTimeout(() => {
                                this.checkAnimation(el);
                            }, 700);
                        }

                    }

                }));

            }, options);

            // Start observing 
            this.$animateEls.forEach((el) => observer.observe(el));

        }

    }

    attachEvents() {

        if (!window.Modernizr.touch) {
            this.observerScroll();
        }
        else {
            this.$animateEls.forEach((el) => {
                TweenMax.set(el, {
                    opacity: 1
                });
            });
        }
    }


}

export default Text;


const _init = () => {

    new Text();
};

_init();

